module.exports = __webpack_public_path__ + "fonts/fa-solid-900.2cd2be17.woff2";